import ReactEcharts from "echarts-for-react"
import React from "react";
const options = {
  grid: { top: 20, right: 40, bottom: 20, left: 40 },
  xAxis: {
    type: "category",
    data: ["Apr", "May", "Jun", "Jul", "Aug","Sep","Oct"]
  },
  yAxis: {
    type: "value"
  },
  series: [
    {
      data: [400, 300, 350, 200, 280, 200, 300],
      type: "bar",
      //showBackground: true,
      color:'#394A7E',
    //   backgroundStyle: {
    //   color: '#9AABDD',
    // },
      smooth: true,

      itemStyle: {
        emphasis: {
            barBorderRadius: [50, 50,50,50]
        },
        normal: {
            barBorderRadius: [50, 50, 50 ,50 ]
        },
    }
  }
  ],
  tooltip: {
    trigger: "axis"
  }
}

function BarChart() {
  return (
    <ReactEcharts
      option={options}
      style={{ width: "400px", height: "200px"}}
    ></ReactEcharts>
  )
}

export default BarChart;
